import React, { useEffect, useState } from 'react'
import { Listbox } from '@headlessui/react'
import SelectArrow from '@/assets/ic_arrow_select.svg?react'
import { equalString } from '@/util/strings.ts'

export interface ISelectOption {
    id: string
    text?: string
    value?: any
}

interface IProps {
    className?: string
    onChanged: (value: ISelectOption) => void
    options: Array<ISelectOption>
    selectedId?: string
    value?: ISelectOption
    disabled?: boolean
}


const Select: React.FC<IProps> = ({
                                      onChanged,
                                      options = [],
                                      className,
                                      disabled = false,
                                      selectedId,
                                      value
                                  }) => {
    const [selectValue, setSelectValue] = useState(options[0])

    useEffect(() => {
        const selectedOption = options?.find(item => equalString(item?.id, selectedId))
        if (selectedOption) {
            setSelectValue(selectedOption)
            onChanged(selectedOption)
        }
    }, [selectedId])

    useEffect(() => {
        setSelectValue(value ?? options[0])
    }, [value])

    const displayedValue = options.find(option => equalString(option?.id, selectValue?.id)) ?? selectValue

    return (
        <div className={`ui-select min-w-[100px] ${className || ''}`}>
            <Listbox value={selectValue} onChange={setSelectValue} disabled={disabled}>
                {({ open }) => {
                    return (
                        <div
                            className={`ui-select__control relative w-full box-border cursor-pointer ${
                                disabled ? 'bg-[#F5F5F5]' : 'bg-sub_b'
                            }`}>
                            <Listbox.Button
                                className={'flex justify-between w-full py-[12px] pl-[15px] pr-[13px]'}>
                                <p className={`text-input text-[14px] font-normal`}>{displayedValue?.text}</p>
                                <SelectArrow className={''} />
                            </Listbox.Button>

                            {open && (
                                <Listbox.Options
                                    className={'ui-select__options absolute select-none w-full mt-2.5 z-dropdown max-h-[348px] overflow-y-auto overflow-hidden bg-white'}>
                                    {options.map(option => {
                                        return (
                                            <Listbox.Option
                                                className={'ui-select__option relative select-none py-[13px] px-[16px] w-full flex items-center font-medium text-center justify-center cursor-pointer'}
                                                key={option.id}
                                                value={option}
                                                onClick={() => {
                                                    onChanged(option)
                                                }}>
                                                <p className={`whitespace-nowrap truncate`}>
                                                    {option.text}
                                                </p>
                                            </Listbox.Option>
                                        )
                                    })}
                                </Listbox.Options>
                            )}
                        </div>
                    )
                }}
            </Listbox>
        </div>
    )
}

export default Select
